import React from 'react';
import '../../styles/sections.css';
import '../../styles/challenges.css';

const Challenges = () => (
  <div className="challenges-section">
    <div className="section-header">
      <h2>CHALLENGES</h2>
      <div className="underline"></div>
    </div>
    <div className="challenges-content">
      <h3>Technical Challenges</h3>
      <ul>
        <li><strong>Physics Optimization:</strong> Balancing realistic climbing and parkour physics with smooth, responsive gameplay.</li>
        <li><strong>Multiplayer Synchronization:</strong> Keeping gas movement, checkpoints, and player states consistent across all players.</li>
        <li><strong>Performance Scaling:</strong> Maintaining stable 60 FPS on a wide range of devices (low-end mobile → high-end PC).</li>
        <li><strong>Level Design & Generation:</strong> Crafting obstacle layouts that feel fresh, engaging, and non-repetitive.</li>
        <li><strong>Data Management:</strong> Securely storing player progress, currencies, and purchases while minimizing load times.</li>
        <li><strong>Shop & Inventory Systems:</strong> Supporting real-money purchases (Robux) alongside in-game currency with seamless syncing.</li>
        <li><strong>Leaderboard Integrity:</strong> Preventing exploits and ensuring fair competition for leaderboard rewards.</li>
      </ul>

      <h3>Design Challenges</h3>
      <ul>
        <li><strong>Difficulty Balancing:</strong> Making maps challenging without being frustrating, with a fair skill curve.</li>
        <li><strong>Player Engagement:</strong> Encouraging long-term replayability through progression, unlocks, and rewards.</li>
        <li><strong>Accessibility:</strong> Ensuring the game is enjoyable for both casual players and competitive climbers.</li>
        <li><strong>Visual Clarity:</strong> Designing levels and hazards so objectives and obstacles remain easy to read in fast-paced gameplay.</li>
        <li><strong>Control Responsiveness:</strong> Fine-tuning controls to feel intuitive, reliable, and precise across devices.</li>
        <li><strong>Monetization Without Friction:</strong> Creating a shop that enhances gameplay without being pay-to-win.</li>
      </ul>

      <h3>Solutions Implemented</h3>
      <ul>
        <li><strong>Physics Tuning & Optimization:</strong> Custom parkour mechanics with reduced latency and stable collision handling.</li>
        <li><strong>Robust Networking Model:</strong> Client prediction and server reconciliation to keep multiplayer gameplay fair and smooth.</li>
        <li><strong>Adaptive Difficulty Systems:</strong> Dynamic scaling based on player performance and map progression.</li>
        <li><strong>Cross-Device Testing:</strong> Optimized for both mobile and desktop with iterative performance profiling.</li>
        <li><strong>Iterative Map Design:</strong> Playtesting-driven level adjustments to refine difficulty and flow.</li>
        <li><strong>Reward Systems:</strong> Leaderboard-based glow rewards and progression-based unlocks to sustain engagement.</li>
        <li><strong>Player Feedback Integration:</strong> Continuous updates shaped by community testing and feedback loops.</li>
      </ul>
    </div>
  </div>
);

export default Challenges;
